import { applySeo } from "@/lib/seo-head";
import { createFileRoute } from "@tanstack/react-router";
import { Layout } from "@/components/site/Layout";
import { ConfirmationLayout } from "@/components/checkout/ConfirmationLayout";
import { useT } from "@/lib/i18n";

export const Route = createFileRoute("/paquete-confirmado")({
  component: PackageConfirmed,
  head: (ctx) => applySeo(ctx.matches, ((_c: unknown) => {
    const url = "https://rrlexjuristas.com/paquete-confirmado";
    const title = "Pago recibido — RR Lex Juristas";
    const description =
      "Hemos recibido tu solicitud y estamos verificando el pago. Te confirmaremos por email en cuanto se complete.";
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { name: "robots", content: "noindex" },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { name: "twitter:card", content: "summary" },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  })(ctx)),
});

function PackageConfirmed() {
  const { tk } = useT();

  return (
    <Layout>
      <ConfirmationLayout
        eyebrow={tk("paquete.confirmed.eyebrow", "Solicitud registrada")}
        title={tk("paquete.confirmed.title", "Solicitud")}
        titleAccent={tk("paquete.confirmed.title2", "recibida")}
        body={tk(
          "paquete.confirmed.body",
          "Estamos verificando el pago con la pasarela. En cuanto se confirme recibirás un email con los detalles y los siguientes pasos.",
        )}
        waMessage={tk("paquete.confirmed.wa", "Hola, acabo de contratar un servicio en la web.")}
        steps={[
          {
            title: tk("paquete.confirmed.step1.title", "Confirmación por email"),
            body: tk(
              "paquete.confirmed.step1.body",
              "Recibirás el justificante de pago y el resumen del servicio contratado.",
            ),
          },
          {
            title: tk("paquete.confirmed.step2.title", "Contacto del despacho"),
            body: tk(
              "paquete.confirmed.step2.body",
              "Un abogado del equipo te escribirá en menos de 24 horas laborables.",
            ),
          },
          {
            title: tk("paquete.confirmed.step3.title", "Documentación"),
            body: tk(
              "paquete.confirmed.step3.body",
              "Te indicaremos qué documentos necesitamos para iniciar tu expediente.",
            ),
          },
        ]}
      />
    </Layout>
  );
}
